<app-step-wrapper [title]="dataService.steps[1]">
  <form [formGroup]="dataService.enrollmentForm" (click)="dataService.printForm()">
    <ng-container formArrayName="users">
      <ng-container *ngFor="let user of dataService?.enrollmentFormStudentUsers;">
        <app-user-form [uuid]="user?.get('__uuid')?.value"></app-user-form>
      </ng-container>
    </ng-container>
  </form>
</app-step-wrapper>